import Link from '@/components/Link'
import HomeCard from '@/components/custom/home/HomeCard'
import HomeQrCodeImage from '@/components/custom/home/HomeQrCodeImage'
import HomeTipsCard from '@/components/custom/home/HomeTipsCard'
import { HomeTitleLine } from '@/components/custom/home/HomeTitleLine'
import HomeWorldImage from '@/components/custom/home/HomeWorldImage'
import TrustBox from '@/components/custom/other/TrustBox'
import Vector3 from '@/assets/svg/vector-3.svg?react'
import Vector4 from '@/assets/svg/vector-4.svg?react'
import Image from '@/components/Image'
import ArrowDown from '@/assets/svg/arrow-down.svg?react'
import FirenzeLogo from '@/assets/svg/parlano-di-noi/firenze.svg?react'
import LaNazioneLogo from '@/assets/svg/parlano-di-noi/la-nazione.svg?react'
import TheDotCultura from '@/assets/svg/parlano-di-noi/thedotcultura.svg?react'
import TvPratoLogo from '@/assets/svg/parlano-di-noi/tvprato.svg?react'
export default function Home() {
  return (
    <>
      <div className="divide-gray-200 dark:divide-gray-700">
        <div className="grid grid-cols-1 gap-4 pt-6 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2">
          <div className="mb-4 flex flex-col text-5xl sm:text-5xl md:text-7xl md:lg:xl:order-1">
            <h1 className="mb-2 bg-gradient-to-r from-black to-secondary-700 bg-clip-text pr-1 font-bold text-transparent dark:text-white">
              Il tuo menu,
              <br />
              <HomeTitleLine>con sex appeal</HomeTitleLine>
            </h1>
            <div className="mt-6 space-y-5">
              <h2 className="multiline-truncate mt-3 text-2xl text-gray-800 dark:text-gray-100">
                ✅ Attira più clienti nel tuo locale
              </h2>
              <h2 className="multiline-truncate mt-3 text-2xl text-gray-800 dark:text-gray-100">
                ✅ Inseriamo noi il tuo menu
              </h2>
              <h2 className="multiline-truncate mt-3 text-2xl text-gray-800 dark:text-gray-100">
                ✅ Modifica e aggiungi con un click
              </h2>
            </div>

            <div className="mt-6 flex w-full justify-center md:justify-start">
              <Link href="/digitalizza-il-tuo-menu">
                <button className="btn mt-6 flex items-center rounded-xl bg-secondary px-6 py-6 text-2xl font-medium tracking-wide text-white hover:bg-secondary-500 dark:bg-primary dark:text-black dark:hover:bg-primary-200">
                  Digitalizza il tuo menu
                </button>
              </Link>
            </div>
          </div>

          <div className="relative order-2 h-[400px] overflow-hidden md:h-[500px]">
            <Image
              className="absolute z-10 h-full w-full object-contain pb-4"
              src={'/static/images/home/meamenuphone.webp'}
              alt={'Telefono'}
              width={72}
              height={72}
              priority
            />
            <div>
              <Vector4 className="absolute h-full w-full object-contain p-10 blur-xl" />
              <Vector3 className="absolute h-full w-full object-contain p-10 blur-xl" />
            </div>
          </div>
        </div>
        <div className="mt-12 divide-y divide-gray-200 dark:divide-gray-700">
          <div />
          <div className="mb-6 grid grid-cols-1 items-center justify-center gap-4 pt-6 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-5 xl:grid-cols-5">
            <div className="flex items-center justify-center text-black dark:text-gray-500">
              <span>Parlano di noi</span>
            </div>
            <div className="flex items-center justify-center">
              <Link
                href="https://www.tvprato.it/2022/10/menu-su-misura-al-ristorante-con-lapp-ideata-da-cinque-giovani-studenti-pratesi"
                className="flex w-full items-center justify-center"
              >
                <TvPratoLogo className="bg-red h-12 w-44" />
              </Link>
            </div>
            <div className="flex w-full items-center justify-center">
              <LaNazioneLogo className="h-12 w-44" />
            </div>
            <div className="flex items-center justify-center">
              <Link
                href="http://met.provincia.fi.it/news.aspx?n=360209"
                className="flex w-full items-center justify-center"
              >
                <FirenzeLogo className="h-12 w-44" />
              </Link>
            </div>
            <div className="flex items-center justify-center">
              <Link
                href="https://www.thedotcultura.it/impresa-campus-vince-unapp-che-sceglie-il-menu-al-ristorante/"
                className="flex w-full items-center justify-center"
              >
                <TheDotCultura className="h-12 w-44" />
              </Link>
            </div>
          </div>
          <div />
        </div>

        <div className="mt-8 flex justify-center">
          <TrustBox />
        </div>

        <div className="lg:h96 grid grid-cols-1 items-center gap-4 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2">
          <div className="items-left justify-left align-left flex">
            <HomeQrCodeImage />
          </div>
          <div className="pb-10 text-center md:lg:xl:text-start">
            <span className="btn-primary mb-4 mr-2 rounded-full bg-secondary-500 px-4 py-2 text-xl font-semibold text-white no-underline shadow-md focus:outline-none active:shadow-none dark:bg-primary-800 dark:text-primary-400">
              Il tuo menu
            </span>

            <h2 className="mt-4 text-5xl font-semibold text-gray-800 dark:text-white">
              Tutto in un QR code
            </h2>
            <p className="multiline-truncate prose mt-3 max-w-none text-2xl text-gray-800 dark:text-gray-400">
              Il tuo cliente accede da web con zero registrazioni.
            </p>
          </div>
        </div>

        <div className="flex flex-col items-center">
          <span className="btn-primary mb-2 mr-2 rounded-full bg-secondary-500 px-4 py-2 text-xl font-semibold text-white no-underline shadow-md focus:outline-none active:shadow-none dark:bg-primary-800 dark:text-primary-400">
            Come funziona
          </span>
        </div>

        <ul className="grid grid-cols-1 gap-4 pb-6 pt-6 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3">
          <li key={'card-1'}>
            <HomeCard
              step={'1'}
              title={'Inserisci il menu'}
              imgSrc={'/static/images/home/Step1.webp'}
              description={'Inserisci le foto del tuo menu e i tuoi dati.'}
            />
          </li>

          <li key={'card-2'}>
            <HomeCard
              step={'2'}
              title={'Digitalizzazione'}
              imgSrc={'/static/images/home/Step2.webp'}
              description={
                'Fornisci il tuo menu e lascia a noi il compito di inserirlo interamente.'
              }
            />
          </li>

          <li key={'card-3'}>
            <HomeCard
              step={'3'}
              title={'Attivazione'}
              imgSrc={'/static/images/home/Step3.webp'}
              description={'Ottieni i QR code e attiva la tua web-app.'}
            />
          </li>
        </ul>

        <ul className="grid grid-cols-1 gap-8 pb-16 pt-6">
          <li key={'long-card-1'} className="sticky top-4">
            <div className="flex h-[600px] flex-col items-center justify-center overflow-hidden rounded-3xl bg-customWhiteBackgroundColor px-4 shadow-[1px_3px_26px_3px_rgba(0,0,0,0.1)] dark:bg-customBackgroundCardColor md:xl:flex-row">
              <Image
                className="order-3 h-[200px] w-auto flex-1 object-contain md:lg:xl:order-1 md:lg:xl:h-[600px]"
                src={'/static/images/home/long-card-1-image.webp'}
                alt={'Immagine che rappresenta:' + 'Digitalizziamo noi il tuo menu'}
                height={100}
                width={100}
              />

              <div className="order-2 flex w-full flex-1 justify-center text-center">
                <div className="mt-6 flex-1 md:mt-0 md:content-center">
                  <span className="btn-primary mb-2 mr-2 rounded-full bg-secondary-500 px-4 py-2 text-xl font-semibold text-white no-underline shadow-md focus:outline-none active:shadow-none dark:bg-primary-800 dark:text-primary-400">
                    Vantaggio
                  </span>
                  <p className="mt-4 block text-4xl font-semibold text-gray-800 dark:text-white">
                    {'Digitalizziamo noi il tuo menu'}
                  </p>
                  <p className="multiline-truncate prose mt-3 max-w-none text-xl text-gray-800 dark:text-gray-400 md:text-2xl">
                    {'La comodità inizia dal primo passo: digitalizziamo noi il tuo menu'}
                  </p>
                </div>
              </div>
            </div>
          </li>
          <li key={'long-card-2'} className="sticky top-4 z-10">
            <div className="grid h-[600px] grid-cols-1 justify-items-center gap-4 rounded-3xl bg-customWhiteBackgroundColor shadow-[1px_3px_26px_3px_rgba(0,0,0,0.1)] dark:bg-customBackgroundCardColor sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2">
              <div className="mt-4 flex min-h-full w-full justify-center text-center">
                <div className="flex-1 content-center">
                  <span className="btn-primary mb-2 mr-2 rounded-full bg-secondary-500 px-4 py-2 text-xl font-semibold text-white no-underline shadow-md focus:outline-none active:shadow-none dark:bg-primary-800 dark:text-primary-400">
                    Vantaggio
                  </span>

                  <p className="mt-4 block text-4xl font-semibold text-gray-800 dark:text-white">
                    {'Massima flessibilità'}
                  </p>

                  <p className="multiline-truncate prose mt-3 max-w-none text-xl text-gray-800 dark:text-gray-400 md:text-2xl">
                    {'Gestisci con un click le stagionalità del tuo menu dalla web-app'}
                  </p>
                </div>
              </div>

              <div className="bg-radial-light dark:bg-radial-dark relative flex w-full items-center justify-center overflow-hidden rounded-3xl bg-clip-border">
                <Image
                  className="h-[500px] w-full rounded-3xl object-contain p-14 md:p-0"
                  style={{
                    borderRadius: '1.5rem',
                    transform: 'rotate(18deg)',
                  }}
                  src={'/static/images/home/long-card-2-image.webp'}
                  alt={'Immagine che rappresenta:' + " l'app di MeaMenu"}
                  height={300}
                  width={300}
                />
              </div>
            </div>
          </li>
          <li key={'long-card-3'} className="sticky top-4 z-20">
            <div className="grid h-[600px] grid-cols-1 justify-items-center gap-4 rounded-3xl bg-customWhiteBackgroundColor px-4 shadow-[1px_3px_26px_3px_rgba(0,0,0,0.1)] dark:bg-customBackgroundCardColor sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2">
              <div className="relative order-3 h-auto w-auto overflow-hidden rounded-xl bg-clip-border md:lg:xl:order-1">
                <Image
                  className="h-full w-auto object-contain"
                  src={'/static/images/home/long-card-3-image.webp'}
                  alt={'Immagine che rappresenta:' + ' nessun problema di connessione'}
                  height={300}
                  width={300}
                />
              </div>
              <div className="order-2 mt-5 flex min-h-full w-full justify-center pb-2 text-center">
                <div className="mt-1 flex-1 md:mt-0 md:content-center">
                  <span className="btn-primary mb-2 mr-2 rounded-full bg-secondary-500 px-4 py-2 text-xl font-semibold text-white no-underline shadow-md focus:outline-none active:shadow-none dark:bg-primary-800 dark:text-primary-400">
                    Vantaggio
                  </span>

                  <p className="mt-4 block text-4xl font-semibold text-gray-800 dark:text-white">
                    {'Senza pensieri per la connessione'}
                  </p>

                  <p className="multiline-truncate prose mt-3 max-w-none text-xl text-gray-800 dark:text-gray-400 md:text-2xl">
                    {'QR code di qualsiasi formato per una connettività senza intoppi'}
                  </p>
                </div>
              </div>
            </div>
          </li>
          <li key={'long-card-4'} className="sticky top-4 z-30">
            <div className="flex h-[600px] flex-col items-center justify-center overflow-hidden rounded-3xl bg-customWhiteBackgroundColor shadow-[1px_3px_26px_3px_rgba(0,0,0,0.1)] dark:bg-customBackgroundCardColor md:xl:flex-row">
              <div className="flex-2 mt-5 flex w-full justify-center px-4 text-center">
                <div className="mt-1 flex-1 md:mt-0 md:content-center">
                  <span className="btn-primary mb-2 mr-2 rounded-full bg-secondary-500 px-4 py-2 text-xl font-semibold text-white no-underline shadow-md focus:outline-none active:shadow-none dark:bg-primary-800 dark:text-primary-400">
                    Vantaggio
                  </span>
                  <span className="btn-primary mb-2 mr-2 rounded-full bg-secondary-500 px-4 py-2 text-xl font-semibold text-white no-underline shadow-md focus:outline-none active:shadow-none dark:bg-primary-800 dark:text-primary-400">
                    AI
                  </span>
                  <p className="mt-4 block text-4xl font-semibold text-gray-800 dark:text-white">
                    {'Menu multilingua'}
                  </p>
                  <p className="prose mt-3 max-w-none text-xl text-gray-800 dark:text-gray-400 md:text-2xl">
                    {
                      'Supera le barriere linguistiche e accogli turisti internazionali con il nostro menù digitale disponibile in 8 lingue.'
                    }
                  </p>
                </div>
              </div>
              <div className="flex-3 flex h-full w-full justify-center overflow-hidden pt-4 md:justify-end md:pt-0">
                <HomeWorldImage />
              </div>
            </div>
          </li>
          <li key={'long-card-5'} className="sticky top-4 z-40">
            <div className="grid h-[600px] grid-cols-1 justify-items-center gap-4 rounded-3xl bg-customWhiteBackgroundColor px-4 shadow-[1px_3px_26px_3px_rgba(0,0,0,0.1)] dark:bg-customBackgroundCardColor sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2">
              <div className="relative order-3 h-auto w-auto overflow-hidden rounded-xl bg-clip-border py-6 md:lg:xl:order-1">
                <Image
                  className="h-full w-auto rounded-3xl object-cover"
                  src={'/static/images/home/long-card-5-image-2.webp'}
                  alt={'Immagine che rappresenta:' + ' stand per QR codes'}
                  height={40}
                  width={40}
                />
              </div>
              <div className="order-2 mt-5 flex w-full justify-center text-center">
                <div className="mt-1 flex-1 md:mt-0 md:content-center">
                  <span className="btn-primary mb-2 mr-2 rounded-full bg-secondary-500 px-4 py-2 text-xl font-semibold text-white no-underline shadow-md focus:outline-none active:shadow-none dark:bg-primary-800 dark:text-primary-400">
                    Vantaggio
                  </span>

                  <p className="mt-4 block text-4xl font-semibold text-gray-800 dark:text-white">
                    {'Lo stile prima di tutto'}
                  </p>

                  <p className="prose mt-3 max-w-none text-xl text-gray-800 dark:text-gray-400 md:text-2xl">
                    {
                      "Ti consigliamo noi i migliori supporti QR code: disponibili in vari stili, si adattano perfettamente all'estetica del tuo locale."
                    }
                  </p>
                </div>
              </div>
            </div>
          </li>
        </ul>

        <div
          className={`my-6 flex flex-col items-center justify-between rounded-xl p-10 text-center shadow-orangeBoxShadow dark:shadow-greenBoxShadow xl:p-32`}
        >
          <h1 className="bg-gradient-to-r from-black to-secondary-700 bg-clip-text text-4xl font-bold tracking-tight dark:from-gray-200 dark:to-slate-300 md:text-4xl xl:text-7xl">
            Ottieni il meglio
            <br />
            <HomeTitleLine>
              <div className="pb-2">adesso</div>
            </HomeTitleLine>
          </h1>
          <div className="arrow">
            <ArrowDown className="h-20 w-44 text-secondary-300 dark:text-primary-500" />
          </div>
          <div className="flex w-full justify-center">
            <Link href="/digitalizza-il-tuo-menu">
              <button className="btn mt-3 flex items-center rounded-xl bg-secondary px-6 py-6 text-xl font-medium tracking-wide text-white hover:bg-secondary-500 dark:bg-primary dark:text-black dark:hover:bg-primary-200 xl:text-2xl">
                Digitalizza il tuo menu
              </button>
            </Link>
          </div>
        </div>
        <ul className="grid grid-cols-1 gap-4 pb-6 pt-10 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3">
          <li key={'tip-card-1'}>
            <HomeTipsCard
              title={'Facile modifica del menu'}
              label={false}
              description={'Aggiorna facilmente il tuo menu in pochi click, senza complicazioni.'}
              iconSrc={'one'}
            />
          </li>

          <li key={'tip-card-2'}>
            <HomeTipsCard
              title={'Attira più clienti nel tuo locale'}
              label={false}
              description={
                "Migliora l'immagine del tuo locale e attira più clienti con un’interfaccia facile e intuitiva."
              }
              iconSrc={'two'}
            />
          </li>

          <li key={'tip-card-3'}>
            <HomeTipsCard
              title={'Aiuta i tuoi clienti a scegliere'}
              label={'AI'}
              description={
                'Il tuo cliente sceglie il suo piatto ideale con suggerimenti personalizzati.'
              }
              iconSrc={'three'}
            />
          </li>

          <li key={'tip-card-4'}>
            <HomeTipsCard
              title={'Ordini real-time'}
              label={'In arrivo'}
              description={
                'Ordina al volo: utilizza un servizio di ordinazioni rapido e senza attese.'
              }
              iconSrc={'four'}
            />
          </li>

          <li key={'tip-card-5'}>
            <HomeTipsCard
              title={'Prenotazione dei tavoli'}
              label={'In arrivo'}
              description={'Prenota comodamente da casa con il nostro servizio online intuitivo.'}
              iconSrc={'five'}
            />
          </li>

          <li key={'tip-card-6'}>
            <HomeTipsCard
              title={'Rifornimento smart'}
              label={'In arrivo'}
              description={
                'Assicurati un rapporto di qualità con i tuoi fornitori grazie al nostro servizio dedicato.'
              }
              iconSrc={'six'}
            />
          </li>
        </ul>
      </div>
    </>
  )
}
